module.exports = __webpack_public_path__ + "img/ty-button.a573a9a5.png";